
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/author/amber-martinez",
      function () {
        return require("private-next-pages/articles/author/amber-martinez.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/author/amber-martinez"])
      });
    }
  